import axios from 'axios';

const URL_PUBLIC = '/psscPublic';
const BASE_URL = process.env.VUE_APP_HTTP_PATH;

const defaultOptions = {
    baseURL: BASE_URL,
    responseType: 'json'
};

const axiosInstance = axios.create(defaultOptions);

export default {
    buscarDadosTrilha(payload) {
        let fullUrl = URL_PUBLIC + `/dados-trilha-regularizacao/representante/${payload.idTerritorio}/${payload.idRepresentante}`;
        return axiosInstance.get(fullUrl);
    },

    atualizarStatusTrilha(payload) {
        let fullUrl = URL_PUBLIC + `/atualizar/status-trilha/${payload.idTerritorio}/${payload.idRepresentante}`;
        return axiosInstance.get(fullUrl);
    },

    buscarDadosTrilhaUsuarioLogado(payload) {
        let fullUrl = URL_PUBLIC + `/dados-trilha-regularizacao/${payload.idTerritorio}/${payload.idUsuarioLogado}`;
        return axiosInstance.get(fullUrl);
    },

    dispararTrilha(payload) {
        let fullUrl = URL_PUBLIC + `/enviar-trilha/${payload.idTerritorio}/${payload.idUsuarioLogado}`;
        return axiosInstance.get(fullUrl);
    }
};
